import Form from './Template/Form'

const Builder = () => {
  return (
    <div id="flow-template-builder">
      <Form />
    </div>
  )
}

export default Builder
